export const DEFAULT_ZOOM = 12;
export const MAP_API_KEY = 'AIzaSyDriMlE_FE1mHCpyut0QSJMqpmzSqIiADQ';
export const GOOGLE_MAPS_BASE_API = 'https://maps.googleapis.com/maps/api';
export const USERNAME = 'denso';
export const PASS = 'xrt5u22dju7uoev008fg';
export const CITY_ZOOM = 11;
export const DESKTOP_WIDTH = 1024;
